import React, { useState, useContext } from "react";
import context from "../GlobalData/dataProvider";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

import Button from "@material-ui/core/Button";
// import { data } from "./data";
import "./radioGroup.css";
import { useNavigate } from "react-router-dom";
import { data } from "./quizzData";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1, 3, 0, 0),
  },
}));

export default function Forms() {
  let navigate = useNavigate();
  let dataContext = useContext(context);

  const classes = useStyles();
  const [value, setValue] = React.useState("");
  const [error, setError] = React.useState(false);
  const [decriptionState, setdecriptionState] = useState(false);
  const [helperText, setHelperText] = React.useState("");
  let [score, setscore] = useState(dataContext);
  let [questionIncremnt, setquestionIncremnt] = useState(0);

  const handleRadioChange = (event) => {
    setValue(event.target.value);
    setHelperText(" ");
    setError(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log("Value : ", value);
    data[questionIncremnt].options.forEach((val, ind) => {
      if (val.name === value) setscore(score + val.Score);
    });

    setquestionIncremnt(questionIncremnt + 1);
  };
  if (questionIncremnt < 10) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        {helperText}
        <div className="box">
          <form onSubmit={handleSubmit}>
            <FormControl
              component="fieldset"
              error={error}
              className={classes.formControl}
            >
              <FormLabel
                component="legend"
                style={{
                  color: "white",
                  fontSize: "30px",
                  fontFamily: "serif",
                }}
              >
                {data[questionIncremnt].question}
              </FormLabel>
              <RadioGroup
                aria-label="quiz"
                name="quiz"
                value={value}
                onChange={handleRadioChange}
              >
                {data[questionIncremnt].options.map((val, ind) => {
                  return (
                    <div
                      key={ind}
                      style={{
                        border: "solid",
                        marginTop: "10px",
                        textAlign: "left",
                      }}
                    >
                      {" "}
                      <FormControlLabel
                        type="radio"
                        style={{ width: "100%" }}
                        value={val.name}
                        control={<Radio />}
                        label={val.name}
                      />
                       {decriptionState&&<FormHelperText
                        style={{ color: "white", overflow: "hidden" }}
                      >
                        {val.Description}
                      </FormHelperText>}
                    </div>
                  );
                })}
              </RadioGroup>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  
                  variant="contained"
                  color="primary"
                  onClick={()=>{setdecriptionState(true)}}
                  style={{backgroundColor:"white", color:"black"}}
                  className={classes.button}
                >
                  Check Answer
                </Button>
              </div>
              <div style={{ display: "flex", justifyContent: "center"  }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={()=>{setdecriptionState(false)}}

                  style={{backgroundColor:"white", color:"black"}}
                  className={classes.button}
                >
                  Next Question
                </Button>
              </div>
            </FormControl>
          </form>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="box">
            <h1>Your Score : {score} points</h1>
            <h5 style={{ textAlign: "justify", padding: "20px" }}>
              This risk assessment tool may ONLY help you decide if you need an
              HIV test. If you score ABOVE 50 POINTS (not percent), we recommend
              an HIV test. However, your score does not mean you do not  have
              HIV. The only way to know if you have HIV is to get tested free at
              any of our partner center. Contact us for more detail
            </h5>
            <Button
              variant="contained"
              color="primary"
              style={{backgroundColor:"white",color:"black"}}
              onClick={() => {
                navigate("/");
              }}
            >
              {" "}
              Go Back
            </Button>
          </div>
        </div>
      </>
    );
  }
}
